import React, { useState, useEffect, useContext } from "react";
import { UserContext, getCurrentToken } from "./context/UserContext";
import { useNavigate } from "react-router-dom";
import requests from "./base";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const MySwal = withReactContent(Swal);

const Products = () => {
  const { signOut } = useContext(UserContext);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [products, setProducts] = useState([]);
  const [vendorEmail, setVendorEmail] = useState("");
  const [showForm, setShowForm] = useState(false);

  const toggleForm = () => {
    setShowForm((prev) => !prev);
  };

  useEffect(() => {
    const checkToken = async () => {
      const token = getCurrentToken();
      if (!token) {
        navigate("/login");
      } else {
        setVendorEmail(token.Data.FirstName);
        await fetchProducts();
        setLoading(false);
      }
    };
    checkToken();
  }, [navigate]);

  const fetchProducts = async () => {
    try {
      const token = getCurrentToken();
      const vendorID = token.Data.UserId;
      const response = await requests.get(
        `/getvendorproductsbyvendorID?VendorID=${vendorID}`
      );
      if (response?.Data) {
        setProducts(response.Data);
      }
    } catch (error) {
      console.error("Failed to fetch products:", error);
    }
  };

  const showFormPopup = async () => {
    const token = getCurrentToken();
    const vendorID = token.Data.UserId;
    const { value: formValues } = await MySwal.fire({
      title: "Add New Product",
      html: `
        <input id="ProductName" class="swal2-input bg-light border-0" placeholder="Product Name" >
        <select id="CategoryID" class="swal2-input bg-light border-0 mt-3 w-50" style="border: none; border-radius: 8px;">
            <option value="0" class="text-muted" disabled selected>Select Category</option>
               <option  value="1">Seeds</option>
                <option  value="1">Fertilizer</option>
                <option  value="1">Pestcides and Herbicides</option>
                 <option  value="1">Farm Equipment and Machinery</option>
                 
        </select>
        <textarea id="Description" class="swal2-textarea bg-light border-0" placeholder="Description" style="width: 60%; height: 80px;"></textarea>
        <input id="VendorId" class="swal2-input bg-light border-0" placeholder="Vendor ID" hidden type="number">
        <input id="ProductPrice" class="swal2-input bg-light border-0" placeholder="Product Price" type="number">
        <input id="SubsidyAmount" class="swal2-input bg-light border-0" placeholder="Subsidy Amount" type="number">
        <input id="Quantity" class="swal2-input bg-light border-0" placeholder="Quantity" type="number">
         <input id="UploadedImage" type="file" class="swal2-input bg-light border-0" placeholder="Upload Image">
      `,
      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: "Submit",
      cancelButtonColor: "#f5821f",
      preConfirm: async () => {
        const ProductName = document.getElementById("ProductName").value;
        const CategoryID = document.getElementById("CategoryID").value;
        const Description = document.getElementById("Description").value;
        const VendorId = vendorID;
        const ProductPrice = document.getElementById("ProductPrice").value;
        const SubsidyAmount = document.getElementById("SubsidyAmount").value;
        const Quantity = document.getElementById("Quantity").value;
        const imageInput = document.getElementById("UploadedImage");
        const ID = 0;

        if (
          !ProductName ||
          !CategoryID ||
          !VendorId ||
          !ProductPrice ||
          !Quantity
        ) {
          Swal.showValidationMessage("Please fill all required fields.");
          return false;
        }
        const formData = new FormData();
        if (imageInput.files[0]) {
          formData.append("UploadedImage", imageInput.files[0]);
        }
        try {
          Swal.showLoading();

          // Upload image
          const imageResponse = await requests.post(
            "PostFileUpload",
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${token}`,
              },
            }
          );

          // If image upload successful, proceed to submit form
          if (imageResponse.Data && imageResponse.Data.RecordID) {
            const imageID = imageResponse.Data.RecordID;
            console.log("Image uploaded successfully, ID: ", imageID);

            // Prepare payload for product registration
            const payload = {
              sections: [
                {
                  components: [
                    { id: 1, value: ProductName },
                    { id: 2, value: CategoryID },
                    { id: 3, value: Description },
                    { id: 4, value: VendorId },
                    { id: 5, value: ProductPrice },
                    { id: 6, value: SubsidyAmount },
                    { id: 7, value: Quantity },
                    { id: 8, value: ID }, // Include image ID
                    { id: 9, value: imageID },
                  ],
                },
              ],
            };

            // Submit product data along with image ID
            const res = await requests.post("RegisterVendorProduct", payload);
            return res; // Return response from product registration
          } else {
            Swal.showValidationMessage("Image upload failed!");
            return false;
          }
        } catch (err) {
          Swal.showValidationMessage("Submission failed!");
          console.error(err);
          return false;
        }
      },
      customClass: {
        confirmButton: "custom-confirm-btn", // Add custom class to confirm button
      },
    });

    if (formValues) {
      const responseCode = formValues?.ResponseCode;
      const responseText =
        formValues?.ResponseMessage || "Product submitted successfully!";
      if (responseCode === 1) {
        MySwal.fire({
          icon: "success",
          title: "Success",
          text: responseText,
        });
        await fetchProducts(); // Refresh product list
      } else if (responseCode === 0) {
        MySwal.fire({
          icon: "error",
          title: "Error",
          text: responseText || "Something went wrong!",
        });
      } else {
        MySwal.fire({
          icon: "warning",
          title: "Unknown Response",
          text: responseText || "Received an unexpected response.",
        });
      }
    }
  };

  if (loading) return <div>Loading...</div>;

  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) return "Good Morning";
    if (hour < 18) return "Good Afternoon";
    return "Good Evening";
  };
  return (
    <>
      <div className="container mt-4 px-3" style={{ maxWidth: "1200px" }}>
        <div className="row">
          <div
            className="card d-flex flex-row align-items-center p-3 border-0"
            style={{ height: "70px", width: "100%" }}
          >
            <div className="flex-grow-1">
              <h3 className="mb-0 fw-bold">My Products</h3>
            </div>
            <button
              onClick={showFormPopup}
              className="btn m-4 text-white"
              style={{ backgroundColor: "#509f0a", borderRadius: "25px" }}
            >
              Add Product <span className="mdi mdi-plus"></span>
            </button>
            <img
              src="../acre-africa-logo.svg"
              alt="User"
              className="rounded-circle"
              style={{ width: "40px", height: "40px", objectFit: "cover" }}
            />
          </div>
        </div>
        <div className="row mt-3">
          <div
            className="card d-flex flex-row align-items-center p-3 border-0"
            style={{ height: "70px", width: "100%" }}
          >
            <div className="flex-grow-1 mx-2">
              <div className="input-group">
                <input
                  style={{
                    border: "none",
                    backgroundColor: "rgb(243, 243, 243)",
                  }}
                  type="text"
                  className="form-control"
                  placeholder="Search Products... "
                  aria-label="Search"
                />
              </div>
            </div>

            <div className="flex-grow-1 mx-2">
              <select
                name="sort"
                id="sort"
                className="form-select"
                style={{
                  backgroundColor: "#f8f9fa",
                  width: "100%",
                  padding: "0.5rem",
                  borderRadius: "5px",
                  border: "none",
                  backgroundColor: "rgb(243, 243, 243)",
                }}
              >
                <option value="" disabled selected>
                  Category
                </option>
                <option value="volvo">Food</option>
                <option value="saab">Medicine</option>
                <option value="mercedes">Seeds</option>
                <option value="audi">Machines</option>
              </select>
            </div>

            <div className="flex-grow-1 mx-2">
              <select
                name="sort"
                id="sort"
                className="form-select"
                style={{
                  backgroundColor: "#f8f9fa",
                  width: "100%",
                  padding: "0.5rem",
                  borderRadius: "5px",
                  border: "none",
                  backgroundColor: "rgb(243, 243, 243)",
                }}
              >
                <option value="" disabled selected>
                  Approval Status
                </option>
                <option value="volvo">Pending</option>
                <option value="saab">Approved</option>
                <option value="mercedes">Rejected</option>
              </select>
            </div>

            <div className="flex-grow-1 mx-2">
              <select
                name="sort"
                id="sort"
                className="form-select"
                style={{
                  backgroundColor: "#f8f9fa",
                  width: "100%",
                  padding: "0.5rem",
                  borderRadius: "5px",
                  border: "none",
                  backgroundColor: "rgb(243, 243, 243)",
                }}
              >
                <option value="" disabled selected style={{ color: "#6c757d" }}>
                  Sort By
                </option>
                <option value="volvo">Price</option>
                <option value="saab">Date Created</option>
                <option value="mercedes">Category</option>
                <option value="audi">Type</option>
              </select>
            </div>
          </div>
        </div> 

        <div className="row mt-4">
          {products.map((product, index) => (
            <div className="col-md-3 mb-4" key={index}>
              <div className="card h-100 shadow-sm">
                <img
                  src={`${product.FilePathURL}`}
                  // onError={(e) => (e.target.src = "../2.jpg")} // This line sets a fallback image
                  className="card-img-top"
                  alt={`${product.ProductName} image`} // Alternative text for accessibility
                  height={"200px"}
                />
                <div className="card-body">
                  <h5 className="card-title fw-bolder">
                    {product.ProductName}
                  </h5>

                  <ul className="list-unstyled">
                    <li>
                      <p>Quantity: {product.Quantity}Kg</p>
                    </li>
                    <li>
                      <div className="d-flex justify-content-between align-items-center">
                        <h6 className="card-title text-muted fw-bolder mb-0">
                          Ksh.{product.ProductPrice}
                        </h6>

                        {product.status?.toLowerCase() === "approved" && (
                          <span
                            className="mdi mdi-check-circle"
                            style={{
                              fontSize: "25px",
                              color: "green",
                              marginLeft: "8px",
                            }}
                          ></span>
                        )}

                        {product.status?.toLowerCase() === "pending" && (
                          <span
                            className="mdi mdi-clock-time-four"
                            style={{
                              fontSize: "25px",
                              color: "orange",
                              marginLeft: "8px",
                            }}
                          ></span>
                        )}

                        {product.status?.toLowerCase() === "canceled" && (
                          <span
                            className="mdi mdi-alpha-x-circle"
                            style={{
                              fontSize: "25px",
                              color: "red",
                              marginLeft: "8px",
                            }}
                          ></span>
                        )}
                      </div>
                    </li>

                    {/* <li>
                      <strong>Quantity:</strong> {product.Quantity}
                    </li>
                    <li>
                      <strong>Subsidy:</strong> Ksh.{product.SubsidyAmount}
                    </li> */}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Products;
